// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/Drawer.tsx with go/sail-next-tailor-docs-publisher 

import React, { useState } from 'react';
import { Drawer, Button, CreationDrawer, CreationDrawerHeader, CreationDrawerFooter } from '@sail/ui';
import { AnimatePresence, view, deprecatedCss } from '@sail/engine';
const contentStyle = deprecatedCss`
  color: $color-text-primary;
  background-color: $color-background-container;
  font-family: sans-serif;
  height: 120vh;
  border-radius: $radius-default;
`;

const DrawerExample = ({
  blocking = true,
  size = 'medium'
}) => {
  const [open, setOpen] = useState(false);

  function onToggleDrawer() {
    setOpen(!open);
  }

  return <>
      <Button onPress={() => setOpen(true)}>Open {size} drawer</Button>
      <AnimatePresence>
        {open && <Drawer blocking={blocking} size={size} onClose={onToggleDrawer}>
            <CreationDrawerHeader title="Drawer" onClose={onToggleDrawer} slot="header" />
            <CreationDrawerFooter primaryAction={<Button type="primary">Primary action</Button>} secondaryAction={<Button>Secondary action</Button>} slot="footer">
              Footer content
            </CreationDrawerFooter>
          </Drawer>}
      </AnimatePresence>
    </>;
};

const SampleCreationDrawerFooter = ({
  slot,
  primaryAction
}) => <CreationDrawerFooter primaryAction={<Button type="primary" onPress={primaryAction}>
        Primary action
      </Button>} secondaryAction={<Button onPress={primaryAction}>Secondary action</Button>}>
    Footer
  </CreationDrawerFooter>;

function CreationDrawerExampleContents({
  onClose,
  preview
}) {
  const [showPreview, setShowPreview] = useState(true);

  function onTogglePreview() {
    setShowPreview(!showPreview);
  }

  return <CreationDrawer title="Drawer title" size="medium" showPreview={preview ? showPreview : undefined} onTogglePreview={preview ? onTogglePreview : undefined} onClose={onClose}>
      {preview && <view.div slot="preview" uses={[deprecatedCss`
              width: 500px;
            `]} />}

      <view.div uses={[contentStyle]} />

      <SampleCreationDrawerFooter slot="footer" primaryAction={onClose} />
    </CreationDrawer>;
}

const CreationDrawerExample = ({
  preview = false
}) => {
  const [open, setOpen] = useState(false);

  function onToggleDrawer() {
    setOpen(!open);
  }

  return <div>
      <Button onPress={() => setOpen(true)}>Open drawer</Button>
      <AnimatePresence>
        {open && <CreationDrawerExampleContents onClose={onToggleDrawer} preview={preview} />}
      </AnimatePresence>
    </div>;
};

const CreationDrawerBasicHeaderExample = () => <CreationDrawerHeader title="Basic header" onClose={() => null} uses={[deprecatedCss`width: 100%;`]} />;

const CreationDrawerMultistepHeaderExample = () => <CreationDrawerHeader title="Title of this step" onClose={() => null} subtitle="Title of flow" currentStep={1} totalSteps={3} uses={[deprecatedCss`width: 100%;`]} />;

const CreationDrawerFooterExample = () => <CreationDrawerFooter primaryAction={<Button type="primary">Primary action</Button>} secondaryAction={<Button>Secondary action</Button>} uses={[deprecatedCss`width: 100%;`]}>
    Footer content
  </CreationDrawerFooter>;

const basic = {
  rendered: <>
      <DrawerExample size="small" />
      <DrawerExample />
      <DrawerExample size="large" />
    </>,
  source: `const [open, setOpen] = useState(false);

function onToggleDrawer() {
  setOpen(!open);
}

return (
  <>
    <Button onPress={() => setOpen(true)}>Open {size} drawer</Button>

    <AnimatePresence>
      {open && (
        <Drawer size={size} onClose={onToggleDrawer}>
          <CreationDrawerHeader
            title="Drawer"
            onClose={onToggleDrawer}
            slot="header"
          />
          
          <CreationDrawerFooter
            primaryAction={<Button type="primary">Primary action</Button>}
            secondaryAction={<Button>Secondary action</Button>}
            slot="footer"
          >
            Footer content
          </CreationDrawerFooter>
        </Drawer>
      )}
    </AnimatePresence>
  </>
);`
};
const nonBlocking = {
  rendered: <>
      <DrawerExample size="small" blocking={false} />
      <DrawerExample blocking={false} />
      <DrawerExample size="large" blocking={false} />
    </>,
  source: `<>
  <DrawerExample size="small" blocking={false} />
  <DrawerExample blocking={false} />
  <DrawerExample size="large" blocking={false} />
</>`
};
const creationDrawer = {
  rendered: <CreationDrawerExample />,
  source: `const [open, setOpen] = useState(false);

  function onToggleDrawer() {
    setOpen(!open);
  }
  
  return (
    <div>
      <Button onPress={() => setOpen(true)}>Open drawer</Button>
      <AnimatePresence>
        {open && (
          <CreationDrawer
            title="Drawer title"
            size="medium"
            onClose={onClose}
          >
            {preview && (
              <Box slot="preview" />
            )}
          </CreationDrawer>
        )}
      </AnimatePresence>
    </div>
  );`
};
const creationDrawerWithPreview = {
  rendered: <CreationDrawerExample preview />,
  source: `const [open, setOpen] = useState(false);

function onToggleDrawer() {
  setOpen(!open);
}

return (
  <div>
    <Button onPress={() => setOpen(true)}>Open drawer</Button>
    <AnimatePresence>
      {open && (
        <CreationDrawer
          title="Drawer title"
          size="medium"
          showPreview={true}
          onClose={onClose}
        >
          {preview && (
            <Box slot="preview" />
          )}
        </CreationDrawer>
      )}
    </AnimatePresence>
  </div>
);`
};
const creationDrawerBasicHeader = {
  rendered: <CreationDrawerBasicHeaderExample />,
  source: `<CreationDrawerHeader
  title="Basic header"
  onClose={() => null}
/>`
};
const creationDrawerMultiStepHeader = {
  rendered: <CreationDrawerMultistepHeaderExample />,
  source: `<CreationDrawerHeader
  title="Title of this step"
  onClose={() => null}
  subtitle="Title of flow"
  currentStep={1}
  totalSteps={3}
/>`
};
const creationDrawerFooter = {
  rendered: <CreationDrawerFooterExample />,
  source: `<CreationDrawerFooter
  primaryAction={<Button type="primary">Primary action</Button>}
  secondaryAction={<Button>Secondary action</Button>}
>
  Footer content
</CreationDrawerFooter>`
};
export const DrawerExamples = {
  basic,
  nonBlocking,
  creationDrawer,
  creationDrawerWithPreview,
  creationDrawerBasicHeader,
  creationDrawerMultiStepHeader,
  creationDrawerFooter
};